<template>
  <div class="rounded-lg overflow-hidden box-border w-full">
    <div class="scrollable-table-container" :style="tableStyle">
      <table
        class="w-full px-2 relative table-ranking-podium"
        style="border-collapse: separate; border-spacing: 0"
      >
        <thead
          v-if="!isLoading && data.length > 0"
          :style="theadStyle"
          :class="theadClass"
        >
          <tr>
            <th
              v-for="header in headers"
              :key="header"
              :class="[
                'p-4 text-xs sm:text-sm md:text-base',
                header === 'Nome' ? 'text-left' : 'text-center',
              ]"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody v-if="!isLoading" class="bg-white py-6">
          <tr
            v-for="(row, rowIndex) in data"
            :key="rowIndex"
            class="rounded-lg"
          >
            <td
              v-for="(value, colName) in row"
              :key="colName"
              :class="[
                'label text-xs sm:text-sm md:text-base',
                colName === 'name' ? 'text-left' : 'text-center ',
              ]"
            >
              {{ value }}
            </td>
          </tr>
        </tbody>
        <thead v-else>
          <tr>
            <th
              v-for="index in headers.length"
              :key="index"
              :class="['skeleton-header', 'animate-pulse']"
            ></th>
          </tr>
        </thead>
        <tbody v-if="isLoading" class="bg-white">
          <tr
            v-for="rowIndex in skeletonRows"
            :key="rowIndex"
            class="rounded-lg animate-pulse"
          >
            <td
              v-for="colName in headers.length"
              :key="colName"
              :class="['skeleton-cell', 'animate-pulse']"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTable',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    skeletonRows: {
      type: Number,
      default: 10,
    },
    tableStyle: {
      type: Object,
      default: () => ({}),
    },
    theadStyle: {
      type: Object,
      default: () => ({}),
    },
    theadClass: {
      type: Object,
      default: () => ({}),
    },
    headerClasses: {
      type: String,
      default:
        'p-4 text-xs sm:text-sm md:text-base text-center bg-gray-300 rounded h-8',
    },
    cellClasses: {
      type: String,
      default:
        'px-6 py-4 text-xs sm:text-sm md:text-base text-center bg-gray-200 h-8 rounded',
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

.bg-green-success {
  background-color: #e8faf0;
}
.shadow-custom {
  box-shadow: -5px 0 5px 0 rgba(0, 0, 0, 0.05), 5px 0 5px 0 rgba(0, 0, 0, 0.05),
    0 -5px 5px 0 rgba(0, 0, 0, 0.05), 0 5px 5px 0 rgba(0, 0, 0, 0.05);
}
.red-error-10 {
  background-color: #faeaec;
}
.title {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #6d6d6d;
  letter-spacing: 0.15px;
  font-size: 0.75rem;
}
.label {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.25px;
  color: #434343;
}
.text-xxs {
  font-size: 0.625rem;
  line-height: 1rem;
}
.scrollable-tbody {
  padding-top: 50px;
}
.scrollable-table-container {
  display: block;
  max-height: 100%;
  overflow-y: auto;
  scrollbar-color: #114880 transparent;
  scrollbar-width: thin;
}
.scrollable-table-container::-webkit-scrollbar {
  width: 50px;
  height: 50px;
}
.scrollable-table-container::-webkit-scrollbar-track {
  background: transparent;
}
.scrollable-table-container::-webkit-scrollbar-thumb {
  background: #114880;
  border-radius: 8px;
  border: 23px solid transparent;
  background-clip: padding-box;
}
tbody tr:nth-child(even) {
  background-color: #fcf9f9;
}
.table-ranking-podium td,
.table-ranking-podium th {
  padding: 23px 20px;
  border-bottom: 1px solid #e5e7eb;
}
.bg-gray-200 {
  background-color: #e2e8f0;
}
.bg-gray-300 {
  background-color: #cbd5e0;
}
.min-height {
  min-height: 124px;
}
.skeleton-cell {
  background-color: #e2e8f0;
  border-radius: 0;
  height: 20px;
}
.skeleton-header {
  background-color: #cbd5e0;
  border-radius: 0;
  height: 20px;
}
.animate-pulse {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
